import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import fr from "./locales/fr";
import pt from "./locales/pt";

const STORAGE_KEY = "preferred-language";

const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  pt: {
    translation: pt,
  },
};

const normalizeLanguage = (language) => {
  const value = String(language || "en").toLowerCase();

  if (value.startsWith("fr")) {
    return "fr";
  }

  if (value.startsWith("pt") || value.startsWith("pg")) {
    return "pt";
  }

  return "en";
};

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return "en";
  }

  const savedLanguage = window.localStorage.getItem(STORAGE_KEY);
  if (savedLanguage) {
    return normalizeLanguage(savedLanguage);
  }

  return normalizeLanguage(window.navigator.language);
};

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  fallbackLng: "en",
  supportedLngs: ["en", "fr", "pt"],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

i18n.on("languageChanged", (language) => {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, normalizeLanguage(language));
  }

  if (typeof document !== "undefined") {
    document.documentElement.lang = normalizeLanguage(language);
  }
});

if (typeof document !== "undefined") {
  document.documentElement.lang = normalizeLanguage(i18n.language);
}

export default i18n;
